<template>
  <center>
    <div class="card card-body agatrs-card-style">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-3 offset-md-5">
      <Header pageTitle="View ACSAs/IAs" class="card-container"></Header>
      </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-3 offset-md-5">
            <label for="">Country</label>

            <treeselect
              :multiple="false"
              :options="countries"
              :searchable="true"
              v-model="countryId"
            />
          </div>
        </div>

        <div class="col-md-12">
          <el-table
          v-loading="loader"
            expand
            :data="queryData"
            ref="queryData"
            role="table"
            aria-label="Admin ACSA Table"
            @row-click="rowClicked"
          >
          <el-table-column type="expand" :min-width="150" align="left">
              <div slot-scope="test">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Name</th>
                      <th scope="col">File ID</th>
                      <th scope="col">Agreement ID</th>
                      <th scope="col">Download</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="file in test.row.files" :key="file.id">
                      <td style="width: 25%">{{ file.file.name }}</td>
                      <td style="width: 25%">{{ file.id }}</td>
                      <td style="width: 25%">{{ file.agreementId }}</td>
                      <td style="width: 25%">
                        <el-tooltip
                          content="Download Document"
                          :open-delay="300"
                          effect="light"
                          placement="top"
                        >
                          <router-link
                            :to="`/api/acsaagreementfiles/${file.id}`"
                            class="btn-link btn-primary"
                            target="_blank"
                          >
                            <i class="tim-icons icon-cloud-download-93"></i>
                            <span class="hide-if-large-screensize"
                              >Download</span
                            >
                          </router-link>
                        </el-tooltip>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </el-table-column>
        
            <el-table-column
              v-for="column in tableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              sortable
              :prop="column.prop"
              :label="column.label"
            ></el-table-column>

            <el-table-column :min-width="150">
              <div slot-scope="props">
                <a href="#" class="btn-link btn-primary">
                  <span @click="showImplementingAgreementsModal(props.row.id)">
                    <span class="hide-if-large-screensize">Show IA's</span>
                  </span>
                </a>
              </div>
            </el-table-column>

           
          </el-table>
        </div>
      </div>
    </div>
    <!-- Show Edit IA Modal -->
    <b-modal
      ref="showIaModal"
      scrollable
      hide-footer
      hide-header
      no-close-on-backdrop
      size="lg"
      body-class="custom_alert_body"
    >
      <el-table
     
        :data="implementingAgreements"
        role="table"
        aria-label="Implementing Arrangements Table"
      >
      <el-table-column :min-width="80" align="left" label="Actions">
              <div slot-scope="props">
                <el-tooltip
                  content="Download"
                  :open-delay="300"
                  effect="light"
                  placement="top"
                >
                  <router-link
                    :to="`/api/implimentarrangementfiles/${props.row.implimentArrangementId}`"
                    target="_blank"
                    class="btn-link btn-primary"
                  >
                    <i class="tim-icons icon-cloud-download-93"></i>
                    <span class="hidden-xs-only hide-if-small-screensize"
                      >Download</span
                    >
                  </router-link>
                </el-tooltip>
              </div>
            </el-table-column>
        <el-table-column
          v-for="column in iaColumns"
          :key="column.label"
          :min-width="column.minWidth"
          sortable
          :formatter="column.formatter"
          :prop="column.prop"
          :label="column.label"
        >
        </el-table-column>
      </el-table>
      <div class="alert_footer align-center">
        <base-button
          type="primary"
          @click="closeImplementingAgreementsModal()"
          class="btn-primary"
          ><i class="tim-icons icon-double-left"></i> Return to
          Table</base-button
        >
      </div>
    </b-modal>
  </center>
</template>
  
  <script>
import { mapGetters, mapActions } from "vuex";
import { Table, TableColumn, Select, Option, Button } from "element-ui";
import { BaseSwitch } from "@/components";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { Modal } from "@/components";
import axios from "@/axios";
import { BasePagination } from "@/components";
import Header from "@/components/App/Header.vue";
import swal from "sweetalert2";
import Util from "@/util/util";

export default {
  name: "AdminAcsasDashboard",

  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BaseSwitch,
    BasePagination,
    Modal,
    [Select.name]: Select,
    [Option.name]: Option,
    Treeselect,
    Header,
    Button,
  },
  data() {
    return {
      tableColumns: [
        {
          prop: "name",
          label: "ACSA/IA Agreement ",
          minWidth: 150,
          scope: "col",
        },
        {
          prop: "uploadDate",
          label: "Upload Date",
          minWidth: 150,
          scope: "col",
        },
      ],
      downloadColumn: [
        {
          prop: "files",
          label: "Downloads",
          minWidth: 150,
          scope: "col",
        },
      ],
      queryData: [],
      filesData: null,
      countryId: null,
      selectedIaAcsaId: "",
      loader: false,
      implementingAgreements: [],
      iaColumns: [
        {
          prop: "implimentArrangementId",
          label: "IA ID",
          minWidth: 50,
          scope: "col",
        },
        {
          prop: "name",
          label: "Name",
          minWidth: 50,
          scope: "col",
        },
        {
          prop: "remark",
          label: "Remark",
          minWidth: 50,
          scope: "col",
        },
      ],
    };
  },
  async created() {
    this.getAllCountries();
  },
  watch: {
    countryId: function (val) {
      this.countryId = val;
      this.queryData = [];
      this.filesData = [];
      this.allTableData(val);
    },
  },
  computed: {
    ...mapGetters({
      countries: "countries/allCountries",
    }),
  },
  methods: {
    ...mapActions({
      getAllCountries: "countries/getAllCountries",
    }),
    rowClicked(row){
      this.$refs.queryData.toggleRowExpansion(row);
    },
    async allTableData(val) {
      if(val != undefined){
        this.loader = true

      }
      await this.axios
        .get(`/api/acsaagreements/admin/acsas/country/${val}/1/9999999`)
        .then((response) => {
          //Load the data
          let data = response.data.results;
          let d = data.map((item) => {
            let data = {
              id: item.acsaAgreementId,
              name: item.name,
              uploadDate: item.updateDateLabel,
              options: item.implementArrangementCount,
              files: item.files,
            };
            this.queryData.push(data);
            let sortedArray  = this.queryData.sort(function(a,b){
  return  new Date(b.uploadDate) - new Date(a.uploadDate);
});
            this.filesData = sortedArray[0].files;
            return data;
          });
          this.loader = false
        });
    },
    
    showImplementingAgreementsModal(clickedAcsaId) {
      this.selectedIaAcsaId = clickedAcsaId;
      this.getImplementingAgreements();
      this.$refs.showIaModal.show();
    },
    async getImplementingAgreements() {
      await this.axios
        .get(`api/implimentarrangements/agreement/${this.selectedIaAcsaId}`)
        .then((response) => {
          this.implementingAgreements = response.data;
          if (this.implementingAgreements == null) {
            this.implementingAgreements = [
              {
                implimentArrangementId: "N/A",
                name: "N/A",
                remark: "N/A",
              },
            ];
          }
        });
    },
    closeImplementingAgreementsModal() {
      this.$refs.showIaModal.hide();
    },
    downloadIA(fileId, fileName){

    },
  },
};
</script>

<style>
.router-link-exact-active {
  background-color: none;
}
</style>
  